import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {},
    label: {
      fontSize: '1rem',
      color: theme.oysterTheme.extraGrey,
      fontWeight: 500,
    },
    formControlLabel: {
      direction: 'rtl',
      width: '100%',
      margin: '0px',
      '& .MuiFormControlLabel-label': {
        width: '100%',
        marginRight: '15px',
      },
    },
  }),
);

export default useStyles;
